// useOrientationLockHistory.ts
import * as React from "react";
import * as SO from "expo-screen-orientation";
import { addLockEventListener, type LockEvent } from "./orientationLockBus";

export type LockHistoryEntry = LockEvent;

export function useOrientationLockHistory(limit = 50) {
  const [history, setHistory] = React.useState<LockHistoryEntry[]>([]);

  React.useEffect(() => {
    const unsub = addLockEventListener((e) => {
      setHistory((h) => {
        const last = h[h.length - 1];
        // skip exact duplicates in a row (same lock + same method)
        if (last && last.lock === e.lock && last.method === e.method) return h;
        const next = [...h, e];
        return next.length > limit ? next.slice(next.length - limit) : next;
      });
    });
    return () => unsub();
  }, [limit]);

  const clear = React.useCallback(() => setHistory([]), []);
  return { history, clear };
}
